import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronLeftXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10.2996 11.7607C10.0354 12.0451 9.6018 12.0775 9.29859 11.8486L5.73902 8.54981C5.58633 8.40796 5.49983 8.20841 5.49976 8C5.49976 7.7915 5.58626 7.5921 5.73902 7.4502L9.23902 4.2002C9.54252 3.91839 10.0177 3.93584 10.2996 4.23926C10.5811 4.54276 10.5638 5.01802 10.2605 5.29981L7.35328 8L10.3132 10.7559C10.564 11.0414 10.5637 11.4763 10.2996 11.7607Z",
            fill: color
        })
    });

//# sourceMappingURL=chevron-left-xs.js.map